module.exports = __webpack_public_path__ + "static/home-a9787738855e675770f141583350a509.jpg";